import { Icon, XStack } from '@shinetools/lumen-react'
import { PaperclipIcon } from 'lucide-react'
import { ReactElement } from 'react'

import { BillsTableRow } from '../../types/billsTableRow'

interface BillsTableAttachmentCellProps {
  row: BillsTableRow
}

export const BillsTableAttachmentCell = ({ row }: BillsTableAttachmentCellProps): ReactElement | null => {
  return row.hasAttachments ? (
    <XStack align="center">
      <Icon icon={PaperclipIcon} size="small" color="var(--lumen-color-content-neutral-soft)" />
    </XStack>
  ) : null
}
